import { EnrollmentContext } from "@/state";
import { useContext } from "react";
import { createSearchParams, useNavigate } from "react-router";


export const useNavigateSearch = (preserveClient = true) => {
  const navigate = useNavigate();
  const [state, _] = useContext(EnrollmentContext);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (pathname: string, params?: { [key: string]: any }) => {
    let paramsToSend = { ...(params || {}) };

    if (preserveClient && !Object.keys(paramsToSend).includes("client")) {
      paramsToSend = { ...paramsToSend, "client": state.experienceData.experience.identifier };
    }

    navigate({
      pathname: pathname,
      search: `?${createSearchParams(paramsToSend)}`,
    });
  };
};
